import React from 'react';
import { Link } from 'react-router-dom';
import { Twitter, Send, Globe, ArrowUpRight } from 'lucide-react';
import ZeditLogo from './ZeditLogo';

const ZeditFooter = ({ theme = 'light' }) => {
  const isDark = theme === 'dark';
  const products = [
    { label: 'LayerSeek', href: '/layerseek' },
    { label: 'Clips', href: '/clips' },
    { label: 'TrueKOL', href: '/truekol' },
  ];

  const company = [
    { label: 'Contact', href: 'mailto:hi@zedit.io' },
    { label: 'Terms of Service', href: '/layerseek/terms' },
    { label: 'Refund Policy', href: '/layerseek/refunds' },
  ];

  const baseText = isDark ? 'text-white/70' : 'text-[var(--text-secondary)]';
  const mutedText = isDark ? 'text-white/45' : 'text-[var(--text-muted)]';
  const hoverText = isDark ? 'hover:text-white' : 'hover:text-[var(--zedit-ink)]';
  const borderCls = isDark ? 'border-white/10' : 'border-[var(--border-subtle)]';

  return (
    <footer
      className={`border-t ${borderCls} ${
        isDark ? 'bg-black/40 backdrop-blur-xl' : 'bg-white'
      } relative z-10`}
    >
      <div className="container mx-auto px-5 sm:px-8 py-14 md:py-20">
        <div className="grid grid-cols-2 md:grid-cols-12 gap-10">
          <div className="col-span-2 md:col-span-5">
            <ZeditLogo theme={theme} />
            <p className={`text-sm font-light ${mutedText} mt-5 max-w-sm leading-relaxed`}>
              Tangible growth for Web3 companies. A product suite for protocols, founders, and builders ready to ship deals.
            </p>
            <div className="flex gap-2 mt-6">
              {[Twitter, Send, Globe].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  className={`w-9 h-9 rounded-lg border flex items-center justify-center transition-all ${
                    isDark
                      ? 'border-white/15 text-white/60 hover:border-[#C8FD6A] hover:text-[#C8FD6A]'
                      : 'border-[var(--border-primary)] text-[var(--text-muted)] hover:border-[var(--zedit-ink)] hover:text-[var(--zedit-ink)]'
                  }`}
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className={`text-xs uppercase tracking-widest font-semibold ${mutedText} mb-4`}>Products</h4>
            <ul className="space-y-3">
              {products.map((p) => (
                <li key={p.label}>
                  <Link
                    to={p.href}
                    className={`text-sm font-medium ${baseText} ${hoverText} transition-colors flex items-center gap-1`}
                  >
                    {p.label}
                    <ArrowUpRight className="w-3 h-3 opacity-50" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className={`text-xs uppercase tracking-widest font-semibold ${mutedText} mb-4`}>Company</h4>
            <ul className="space-y-3">
              {company.map((c) => (
                <li key={c.label}>
                  <a href={c.href} className={`text-sm font-medium ${baseText} ${hoverText} transition-colors`}>
                    {c.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-span-2 md:col-span-2">
            <h4 className={`text-xs uppercase tracking-widest font-semibold ${mutedText} mb-4`}>Get in touch</h4>
            <a
              href="mailto:hi@zedit.io"
              className={`text-sm font-medium underline-offset-4 hover:underline ${
                isDark ? 'text-[#C8FD6A] hover:text-white' : 'text-[var(--zedit-ink)] hover:text-[var(--accent-hover)]'
              }`}
            >
              hi@zedit.io
            </a>
          </div>
        </div>

        <div className={`flex flex-col md:flex-row md:items-center justify-between gap-4 mt-14 pt-8 border-t ${borderCls}`}>
          <p className={`text-xs ${mutedText}`}>© {new Date().getFullYear()} Zedit Limited. Made for Web3 builders.</p>
          <p className={`text-xs ${mutedText}`}>Registered in RAK DAO, United Arab Emirates.</p>
        </div>
      </div>
    </footer>
  );
};

export default ZeditFooter;
